export const useDonorIdMutation = () => {
    const mutateDonorId = (value: string) => {
        value = value
            .replace(/\s/g, '') // strip spaces
            .replace(/[^a-zA-Z0-9]/g, '') // strip non-alphanumeric characters
            .toUpperCase(); // convert to uppercase

        /**
         * Add spaces to GRID for better readability at these break points. (spaces are stripped to count length consistently)
         * NMDP ID: 9 characters, no spaces
         * GRID: 4 groups of 4 characters, 1 group of 3 characters, separated by spaces
         */

        if (value.length < 19) {
            return value.match(/.{1,4}/g)?.join(' ') || '';
        } else {
            value = value.replace(/^(.{4})(.{4})(.{4})(.{4})(.*)$/, '$1 $2 $3 $4 $5');
            // Remove characters after 23rd character
            return value.replace(/(?<=[a-zA-Z0-9 ]{23}).*/g, '');
        }
    };

    return {
        mutateDonorId,
    };
};
